<template>
  <div class="msg">
    <div>{{ msg }}</div>
  </div>
</template>
<script>
export default {
  name: "Toast",
  props: ["msg"],
  data() {
    return {};
  },
  methods: {},
  mounted: function () {},
};
</script>
<style scoped>
.msg {
  left: 50%;
  top: 50%;
  position: absolute;
  font-size: 14px;
  padding: 5px 10px;
  border-radius: 4px;
  color: white;
  background-color: rgba(0, 0, 0, 0.6);
  transform: translate(-50%, -50%);
  /* transform:相对自身的宽度和高度进行移动 */
  z-index: 999;
}
</style>